<template>
	<Col>
		<Row class="width-100 analytics-table-container py-5 px-6">
			<AnalyticsTableColumn
				v-for="customColumn in customColumns"
				:key="customColumn.key"
				:cellsValues="tableData"
				:cellKey="customColumn.key"
				:columnTitle="customColumn.title"
				class="custom-column flex-align-start"
			>
				<template #cell-content="{ cellValue }">
					<component v-if="customColumn.component" :is="customColumn.component" v-bind="customColumn.getCustomCellProps(cellValue)" />
					<h3 v-else class="reg">{{ cellValue }}</h3>
				</template>
			</AnalyticsTableColumn>
			<AnalyticsTableColumn
				v-for="(value, key) in tableHeadersDisplayValues"
				:key="key"
				:cellKey="key"
				:columnTitle="value"
				:cellsValues="tableData"
			/>
		</Row>
		<Row class="divider pa-5" />
	</Col>
</template>
<script>
import { capitalizeWord } from '@/utils/language-service';
import AnalyticsTableColumn from '@/components/Analytics/Table/AnalyticsTableColumn.vue';
export default {
	name: 'AnalyticsTable',
	components: { AnalyticsTableColumn },
	props: {
		tableHeaders: { type: Array },
		tableData: { type: Array, default: () => [] },
		customColumns: { type: Array, default: () => [] },
	},
	computed: {
		tableHeadersToUse() {
			return this.tableHeaders?.length > 0 ? this.tableHeaders : this.calculatedTableHeaders;
		},
		tableHeadersDisplayValues() {
			const res = {};
			this.tableHeadersToUse.forEach((header) => (res[header] = capitalizeWord(header.replace('_', ' '))));
			return res;
		},
		calculatedTableHeaders() {
			const customColumnsHeaders = this.customColumns.map((column) => column.key);
			return Object.keys(this.tableData[0] || {}).filter((header) => !customColumnsHeaders.includes(header));
		},
	},
};
</script>
<style scoped lang="scss">
.analytics-table-container {
	border-radius: 15px;
	background: var(--white);
	border: 1px solid #e2e7f0;
}
.custom-column {
	min-width: 30%;
	max-width: 30%;
}
</style>
